import { allImages } from './images';
import { SubServices, Blog, Leaders } from '../models/models';
import { BsTwitterX } from "react-icons/bs";
import { LuFacebook, LuYoutube, LuInstagram, LuLinkedin } from "react-icons/lu";
import { ImageGallery } from './DataFiles/Gallery/Imagegallery';
import clientImages from './clientsImage';
import leaders from './DataFiles/leaders';
import { services, subServices } from "./DataFiles/catalog";
import testimonials from './DataFiles/testimonials.mjs';
import blogs from './DataFiles/blogs.mjs';
import branches from './DataFiles/branches.mjs';
import { youtubevideos } from './DataFiles/videos';
import GalleryList from './DataFiles/Gallery/gallery';


const SubServicesdata: { [key: number]: SubServices[] } = subServices



// const clients = [
//     {
//         logo: clientImages.abb,
//         name: "Asea Brown Boveri LTD"
//     },
//     {
//         logo: clientImages.enmas,
//         name: "Enmas Andritz Private Limited"
//     },
//     {
//         logo: clientImages.bpl,
//         name: "Bharat Petroleum"
//     },
//     {
//         logo: clientImages.cairn,
//         name: "Cairn Energy India "
//     },
//     {
//         logo: clientImages.bhel,
//         name: "Bharat Heavy Electrical Limited"
//     },
//     {
//         logo: clientImages.nav,
//         name: "China National Petroleum Corporation"
//     },
//     {
//         logo: clientImages.acer,
//         name: "ArcelorMittal Nippon Steel India Limited (AP)"
//     },
//     {
//         logo: clientImages.adani,
//         name: "ADANI PORTS AND SEZ LIMITED"
//     },
//     {
//         logo: clientImages.aditya,
//         name: "Utkal Alumina International Ltd- DORAGUDA"
//     },
//     {
//         logo: clientImages.agrawal,
//         name: "Ms Agarwal Foundries Pvt Ltd(Ts)"
//     },
//     {
//         logo: clientImages.auro,
//         name: "Auro Infra Private Limited"
//     },
//     {
//         logo: clientImages.baker,
//         name: "Baker Hughes Energy Technology UK Limited (AP)"
//     },
//     {
//         logo: clientImages.balaji,
//         name: "Balaji Amines Limited(Mh)"
//     },
//     {
//         logo: clientImages.bauerengineeringindia,
//         name: "Bauer Engineering India Private Limited(GJ)"
//     },
//     {
//         logo: clientImages.Bekham,
//         name: "Bekem Infra Projects Pvt Ltd(Ts)"
//     },
//     {
//         logo: clientImages.chetna,
//         name: "CHETNA STEEL TUBES PRIVATE LIMITED"
//     },
//     {
//         logo: clientImages.coromonal,
//         name: "COROMANDEL INTERNATIONAL LIMITED(AP)"
//     },
//     {
//         logo: clientImages.dalmiacement,
//         name: "DALMIA CEMENT (BHARAT) LIMITED"
//     },
//     {
//         logo: clientImages.deccan,
//         name: "Deccan Enterprises Pvt Ltd(TS)"
//     },
//     {
//         logo: clientImages.deep,
//         name: "DEEP INDUSTRIES LIMITED-(AP)"
//     },
//     {
//         logo: clientImages.expro,
//         name: "EXPRO NORTH SEA LIMITED(AP)"
//     },
//     {
//         logo: clientImages.FABTECH,
//         name: "Fabtech Projects And Engineers"
//     },
//     {
//         logo: clientImages.Geodis,
//         name: "Geodis India Private Limited (TN)"
//     },
//     {
//         logo: clientImages.GVR_Logo,
//         name: "GVR INFRA EQUIPMENTS"
//     },
//     {
//         logo: clientImages.harshini,
//         name: "HARSHINI EPC PVT LTD(HYD)"
//     },
//     {
//         logo: clientImages.hblbatteries,
//         name: "M/s HBL POWER SYSTEMS LTD(KANDIVALASA)"
//     },
//     {
//         logo: clientImages.hg,
//         name: "H.G.Infra Engineering Limited (AP)"
//     },
//     {
//         logo: clientImages.icsa,
//         name: "International Clearing And Shipping Agency (India) Pvt Ltd (AP)"
//     },
//     {
//         logo: clientImages.ifgl,
//         name: "IFGL Refractories Limited (AP)"
//     },
//     {
//         logo: clientImages.ijm,
//         name: "IJM INDIA INFRASTRUCTURE LIMITED(AP)"
//     },
//     {
//         logo: clientImages.indianbulls,
//         name: "Indiabulls Enterprises Limited-(TS),"
//     },
//     {
//         logo: clientImages.intrach,
//         name: "Interarch Building Products(P) Ltd (TN)"
//     },
//     {
//         logo: clientImages.itcem,
//         name: "ITD Cementation India Limited-(TN)"
//     },
//     {
//         logo: clientImages.jindal,
//         name: "JINDAL STEEL AND POWER LIMITED-VIZAG"
//     },
//     {
//         logo: clientImages.JRSteelLogo,
//         name: "Jai Raj Ispat Limited (AP)"
//     },
//     {
//         logo: clientImages.jsw,
//         name: "JSW STEEL LIMITED"
//     },
//     {
//         logo: clientImages.keller,
//         name: "Keller Ground Engineering India Pvt. Ltd(TN)"
//     },
//     {
//         logo: clientImages.lt,
//         name: "LARSEN AND TOUBRO LIMITED"
//     },
//     {
//         logo: clientImages.maha,
//         name: "My Home Industries Private Limited - (AP)"
//     },
//     {
//         logo: clientImages.mahainfra,
//         name: "MAX INFRA (I) PRIVATE LIMITED"
//     },
//     {
//         logo: clientImages.mahanthi,
//         name: "Mahathi Infra Services Pvt Ltd(Ka)"
//     },
//     {
//         logo: clientImages.mpr,
//         name: "MPR REFRACTORIES LTD"
//     },
//     {
//         logo: clientImages.nalco,
//         name: "NATIONAL ALUMINIUM COMPANY LIMITED-(AP),"
//     },
//     {
//         logo: clientImages.ncl,
//         name: "Ncl Industries Limited(Ap)"
//     },
//     {
//         logo: clientImages.nsEngLogo,
//         name: "NS ENGINEERING COMPANY PVT LTD(TS)"
//     },
//     {
//         logo: clientImages.nsepoxy,
//         name: "NS Epoxy and Fabrication Solutions Pvt Ltd(TS)"
//     },
//     {
//         logo: clientImages.paramount,
//         name: "Paramount Building Solutions Pvt Ltd(AP)"
//     },
//     {
//         logo: clientImages.patil,
//         name: "Patil Rail Infrastructure Pvt Ltd(GJ)"
//     },
//     {
//         logo: clientImages.pennar,
//         name: "PENNAR INDUSTRIES LIMITED"
//     },
//     {
//         logo: clientImages.pillogo,
//         name: "Pipeline Infrastructure Limited(Ap)"
//     },
//     {
//         logo: clientImages.pncinfra,
//         name: "PNC INFRATECH LTD"
//     },
//     {
//         logo: clientImages.ramco,
//         name: "THE RAMCO CEMENTS LIMITED"
//     },
//     {
//         logo: clientImages.relianceindustriesltd,
//         name: "Reliance Industries Limited (TN)"
//     },
//     {
//         logo: clientImages.rhi,
//         name: "RHI Magnesita India Limited (AP)"
//     },
//     {
//         logo: clientImages.SAIL_LOGO_NEW,
//         name: "STEEL AUTHORITY OF INDIA LTD"
//     },
//     {
//         logo: clientImages.sanghvi,
//         name: "Sanghvi Movers Limited"
//     },
//     {
//         logo: clientImages.smslogo,
//         name: "SMS India Private Limited (OD)"
//     },
//     {
//         logo: clientImages.swathi,
//         name: "Swathi Build Tech PVT Ltd(Ts)"
//     },
//     {
//         logo: clientImages.tatasteellogo,
//         name: "TATA STEEL LIMITED"
//     },
//     {
//         logo: clientImages.tatapro,
//         name: "Tata Projects Ltd"
//     },
//     {
//         logo: clientImages.thermal,
//         name: "Thermal System Hyderabad Pvt Ltd (TS)"
//     },
//     {
//         logo: clientImages.ultatech,
//         name: "ULTRATECH ENGINEERING PRIVATE LIMITED"
//     },
//     {
//         logo: clientImages.VAGLOGO3DHKS,
//         name: "Vag Valves India Private Limited(Ts)"
//     },
//     {
//         logo: clientImages.vishwa,
//         name: "VISHWA SAMUDRA ENGINEERING PRIVATE LIMITED"
//     },
//     {
//         logo: clientImages.vizagsteel,
//         name: "Rashtriya Ispat Nigam Limited"
//     },
//     {
//         logo: clientImages.zetwerklogo,
//         name: "ZETWERK MANUFACTURING BUSINESSES PRIVATE LIMITED"
//     }
// ];

const clients = [
    {
        logo: clientImages.bhel,
        name: "Bharat Heavy Electricals Limited"
    },
    {
        logo: clientImages.adani,
        name: "ADANI PORTS AND SEZ LIMITED"
    },
    {
        logo: clientImages.baker,
        name: "Baker Hughes Energy Technology UK Limited"
    },
    {
        logo: clientImages.coromonal,
        name: "COROMANDEL INTERNATIONAL LIMITED"
    },
    {
        logo: clientImages.dalmiacement,
        name: "DALMIA CEMENT (BHARAT) LIMITED"
    },
    {
        logo: clientImages.hblbatteries,
        name: "HBL POWER SYSTEMS LTD"
    },
    {
        logo: clientImages.itcem,
        name: "ITD Cementation India Limited"
    },
    {
        logo: clientImages.jindal,
        name: "JINDAL STEEL AND POWER LIMITED"
    },
    {
        logo: clientImages.lt,
        name: "LARSEN AND TOUBRO LIMITED"
    },
    {
        logo: clientImages.nalco,
        name: "NATIONAL ALUMINIUM COMPANY LIMITED"
    },
    {
        logo: clientImages.ncl,
        name: "Ncl Industries Limited"
    },
    {
        logo: clientImages.ramco,
        name: "THE RAMCO CEMENTS LIMITED"
    },
    {
        logo: clientImages.relianceindustriesltd,
        name: "Reliance Industries Limited"
    },
    {
        logo: clientImages.SAIL_LOGO_NEW,
        name: "STEEL AUTHORITY OF INDIA LTD"
    },
    {
        logo: clientImages.sanghvi,
        name: "Sanghvi Movers Limited"
    },
    {
        logo: clientImages.smslogo,
        name: "SMS India Private Limited"
    },
    {
        logo: clientImages.tatasteellogo,
        name: "TATA STEEL LIMITED"
    },
    {
        logo: clientImages.tatapro,
        name: "TATA PROJECTS LIMITED"
    },
    {
        logo: clientImages.vizagsteel,
        name: "Rashtriya Ispat Nigam Limited"
    },
    {
        logo: clientImages.ongc,
        name: "OIL AND NATURAL GAS CORPORATION LTD"
    },
    {
        logo: clientImages.pillogo,
        name: "Pipeline Infrastructure Limited(Ap)"
    },
];



// const OtherServices: SubServices[] = [
//     {
//         id: 0,
//         heading: "Over Dimensional Cargo",
//         //content:'Throughout the years, PBL has established a solid reputation for its dependable, punctual, cost-efficient, and secure ODC transportation services. Acknowledged and endorsed by the Indian Banks Association, PBL’s expert services in Over Dimension Cargo set it apart as the preferred choice for clients seeking ODC transportation solutions. The company has successfully handled cargo transportation for esteemed clients such as BHPV, HPCL, Vedanta, NTPC, Reliance, NALCO, and TELK in South India. On average, PBL handles the transportation of approximately 30,000 metric tons of ODC goods annually.',
//         content: `<ul><li>PBL's Key Strengths: <ul> <li>Dependable services</li> <li>Punctuality</li> <li>Cost-efficiency</li> <li>Security in ODC transportation</li> </ul> </li><li>PBL's expertise in ODC makes it a trusted partner for reliable transportation. </li> <li>Esteemed Clients Include: <ul> <li>BHPV</li> <li>HPCL</li> <li>Vedanta</li> <li>NTPC</li> <li>Reliance</li> <li>NALCO</li> <li>TELK in South India</li> </ul> </li> <li>PBL handles approximately 30,000 metric tons of ODC goods each year. </li> </ul>`,
//         image: allImages.cargo,
//         reverse: false
//     },
//     {
//         id: 1,
//         heading: "Project Cargo",
//         content: '<ul> <li>PBL specializes in transporting heavy and voluminous cargo for upcoming projects.</li> <li>The company owns diverse equipment and vehicles to handle goods across India.</li> <li>PBL has served clients like Vedanta, BRPL, Essar, CSPC, and Brahmani Industries.</li> <li>It has a presence in all major cities across eastern, western, and southern India.</li> <li>PBL offers cost-efficient services with a dedicated staff and management.</li> <li>Through strategic partnerships, PBL ensures smooth customs, import, and port clearance.</li> </ul>',
//         image: allImages.projectcargo,
//         reverse: true
//     },
//     {
//         id: 2,
//         heading: "Hiring Services",
//         content: '<ul> <li>PBL offers crane rentals for heavy lifting tasks, providing reliable and safe equipment for various industries and projects.</li> <li>We also rent out trailers, ideal for transporting oversized and heavy cargo with secure and efficient loading and unloading capabilities.</li> <li>Our manlifts are available for rent to assist with tasks at height, ensuring safety and convenience in construction, maintenance, and other high-access tasks.</li> <li>PBL offers forklift rentals for efficient material handling in warehouses, construction sites, and industrial settings.</li> </ul>',
//         image: allImages.hiring,
//         reverse: false
//     },
//     {
//         id: 3,
//         heading: "Material Handling Services",
//         content: '<ul> <li>PBL specializes in transporting heavy and voluminous cargo for upcoming projects.</li> <li>The company owns equipment and vehicles to handle goods across India.</li> <li>PBL has served clients like Vedanta, BRPL, Essar, CSPC, and Brahmani Industries.</li> <li>With a presence in major cities across India, PBL offers cost-efficient services.</li> <li>Dedicated staff and customized partnerships in import regulations, customs, and port clearance have earned PBL highly satisfied customers.</li> </ul> ',
//         image: allImages.material,
//         reverse: true
//     },
//     {
//         id: 4,
//         heading: "Custom's House Agency Services",
//         content: '<ul> <li>PBL has a solid reputation for dependable, punctual, cost-efficient, and secure ODC transportation services.</li> <li>Acknowledged by the Indian Banks Association, PBL is a preferred choice for ODC transportation solutions.</li> <li>The company has handled cargo for clients like BHPV, HPCL, Vedanta, NTPC, Reliance, NALCO, and TELK in South India.</li> <li>PBL transports approximately 30,000 metric tons of ODC goods annually.</li> </ul>',
//         image: allImages.agency,
//         reverse: false
//     },
// ]
var strengths: SubServices[] = [
    {
        id: 0,
        heading: "OWN WORKSHOP",
        content: "The company operates a fully integrated workshop spanning 4 acres, dedicated to the maintenance and management of its extensive fleet, including Trailers, Hydraulic Trailers, Cranes, Man-lifts, and Forklifts. We strictly adhere to the service and maintenance schedules recommended by the manufacturers to ensure safe and efficient operations. Our personnel receive regular training, and their skills are continually upgraded through programs provided by the equipment manufacturers. Additionally, we send our staff to various orientation and skill development courses to stay current with the latest industry trends and practices.",
        image: allImages.workshop,
        reverse: true
    },
    {
        id: 1,
        heading: "OUR PEOPLE",
        content: `<p>PBL combines a rich blend of experience and expertise, transitioning from a family-run business to a professionally managed organization. With over 300 employees, we foster a collaborative environment where team members across various verticals work together to understand and meet customer requirements. Our employees are motivated by supportive HR systems and policies that promote fairness, while continuous skill development and training aligned with job profiles empower individuals to take initiative beyond their assigned roles.</p>`,
        image: allImages.ourpeople,
        reverse: false
    },
    {
        id: 2,
        heading: "MOBILE SERVICE UNIT",
        content: `<div><p>In the event of a breakdown, we have a dedicated mobile service van fully equipped with essential spares, tools, and infrastructure to promptly attend to the issue on-site. Our mobile service team is trained to handle a wide range of repairs and maintenance tasks, ensuring that we can address most breakdowns quickly and efficiently, minimizing downtime. This proactive approach not only helps us maintain the high standards of service we promise to our customers but also ensures that any disruption to their operations is kept to an absolute minimum.</p>
<p>By dispatching our mobile service van, we eliminate the need for the equipment to be transported back to the workshop, which could cause delays and additional costs. This service is designed to enhance customer satisfaction by providing quick, reliable, and cost-effective solutions, allowing us to get the fleet back on the road with as little interruption as possible.</p>
<p>Our mobile service vans are strategically located and equipped to handle a variety of emergency situations, demonstrating our commitment to offering on-the-go support and ensuring that our clients’ operations continue smoothly, even in unexpected circumstances.</p></div>
`,
        image: allImages.mbs,
        reverse: true
    },
    {
        id: 3,
        heading: "OVER DIMENSIONAL CONSIGNMENTS",
        content: `<div><p>PBL specializes in handling large, over-length, and over-height ODC cargo by deploying a diverse range of equipment, including semi-low bed and low bed mechanical trailers, as well as hydraulic axles. To meet specific customer needs, we also utilize specially designed trailers tailored for unique transportation requirements. Our fleet is equipped to handle the most complex and demanding logistics challenges, ensuring safe and efficient transportation of oversized cargo.</p>
<p>In addition to providing the necessary equipment, PBL places a strong emphasis on managing all statutory aspects of oversized cargo transport. We take care of obtaining all the necessary permits and clearances required for such material, ensuring full compliance with local and national regulations. Our team’s deep knowledge of the logistics industry and its cost structures allows us to deliver cost-effective solutions while maintaining the highest standards of safety and reliability.</p>
<p>We work closely with our customers to understand their specific requirements and provide tailored solutions that meet their timelines and budget, while mitigating potential delays and roadblocks associated with transporting large or non-standard cargo.</p></div>
`,
        image: allImages.odc,
        reverse: false
    },
    {
        id: 4,
        heading: "ROUTE MAPPING SURVEYS",
        content: `<div><p>When transporting ODC (Over-Dimensional Cargo) or heavy lift consignments, PBL conducts comprehensive route surveys to identify potential obstacles and determine the most efficient and safe path for the shipment. These surveys allow us to address any challenges proactively, plan alternative routes, and ensure that all logistics requirements are met seamlessly.</p> <p>We leverage our extensive experience and expertise in handling such complex movements, combined with the latest technology, to optimize route planning and minimize risks. Our dedicated team of professionals works closely with local authorities and other stakeholders to ensure smooth operations.</p> <p>By utilizing a strong knowledge base built from years of successful project execution, PBL ensures that each ODC or heavy lift consignment is moved safely, on time, and in full compliance with regulatory standards. This meticulous planning and attention to detail allow us to deliver tailored solutions that meet the specific needs of our clients, no matter the complexity of the shipment.</p></div>`,
        image: allImages.routing,
        reverse: true
    },
    {
        id: 5,
        heading: "HEAVY LIFT CONSIGNMENTS",
        content: `<div><p>PBL specializes in handling heavy lift consignments with a well-planned, strategic approach that ensures timely and efficient execution. We employ a carefully balanced mix of owned and hired fleet, which allows us to mobilize the appropriate equipment based on the specific needs of each customer. This flexibility ensures that we can adapt quickly to varying requirements, whether it's a one-time project or an ongoing shipment.</p> <p>Our fleet is specifically chosen and maintained to handle the unique challenges of heavy lift transport, and we coordinate every aspect of the operation with precision. From initial planning to execution, our team ensures that each heavy lift consignment is managed with the utmost care, safety, and attention to detail, delivering the cargo on schedule and in optimal condition.</p> <p>By combining our fleet flexibility, expert knowledge, and extensive experience, PBL is able to provide tailored solutions that meet the most complex and demanding transportation needs of our customers.</p></div>`,
        image: allImages.cargo,
        reverse: false
    },
    {
        id: 6,
        heading: "TECHNOLOGY",
        content: `<div><p>PBL operates a fully integrated ERP-based Service and Asset Management system, designed to streamline timely maintenance and efficient tracking of our entire fleet. This system manages core business processes such as HR, Marketing, Operations, Motor Licensing, Vendor Management, Maintenance, Procurement, and Accounting.</p> <p>We offer flexible visibility for enroute consignments, utilizing GPS tracking and other advanced technologies. Our fleet is equipped with GPS Fuel and Live Route tracking, TPMS (Tire Pressure Monitoring System), and ADAS (Advanced Driver Assistance System) for enhanced vehicle and driver monitoring. This includes features such as vehicle and driver camera monitoring, and tracking of driver behaviour metrics like harsh acceleration/braking, excessive idling, speeding, and more—data that is displayed on individual Driver Scorecards.</p> <p>Additionally, we use ZF Trailer Pulse software to address trailer operational needs, transforming our trailer fleet into intelligent, interconnected assets. This technology optimizes performance, enhances fleet safety, and minimizes operational costs effectively.</p> <p>Our trailers are equipped with an air pneumatic suspension system, which uses compressed air to support the trailer's weight and ensure a smooth ride, also known as air suspension or pneumatic springs.</p></div>`,
        image: allImages.hiring,
        reverse: true
    },
    {
        id: 7,
        heading: "PROCESSES",
        content: `<div><p>PBL employs a comprehensive system of Process Flows and Standard Operating Procedures (SOPs) that govern every aspect of our operations. These processes are continuously evaluated and refined to meet the ever-evolving needs of our customers, ensuring that we maintain industry-leading practices and consistently deliver high-quality results.</p> <p>In our pursuit of operational excellence, PBL has fully embraced a paperless environment, leveraging mobile applications and digital platforms. This approach facilitates real-time communication, monitoring, and tracking of activities, enabling us to provide unmatched flexibility and responsiveness in fulfilling customer needs.</p> <p>Moreover, we have established a robust network of Application Programming Interfaces (APIs) across all levels of our operations, allowing seamless data exchange between our internal ERP system and external online platforms. This integration enhances real-time visibility, ensures data accuracy, and streamlines information flow, thereby optimizing both internal efficiency and customer service.</p> <p>To further simplify and enhance financial operations, PBL has adopted a completely cashless transaction system. By utilizing secure digital payment solutions, we ensure fast, transparent, and efficient financial transactions, minimizing the risk of errors and delays, and eliminating the need for physical cash handling.</p> <p>PBL is certified by Bureau Veritas, reinforcing our steadfast commitment to maintaining the highest standards of quality and health and safety. Our operations adhere to ISO 9001:2015 (Quality Management) and ISO 45001:2015 (Occupational Health and Safety) standards, ensuring the delivery of superior services while maintaining a safe, compliant, and secure work environment.</p> <p>By integrating certified quality and safety processes with advanced technology, seamless system integrations, and a commitment to cashless transactions, PBL stays at the forefront of the industry—providing reliable, customer-centric solutions while continuously enhancing operational efficiency.</p></div>`,
        image: allImages.process,
        reverse: false
    },
    {
        id: 8,
        heading: "FINANCES",
        content: `<div><p>A number of key control parameters play a central role in the financial corporate management of PBL. We maintain longstanding banking relationships with reputable financial institutions, ensuring smooth financial operations. Our disciplined approach to financial management extends to our suppliers and partners, where we employ convenient and efficient payment mechanisms to facilitate transactions.</p> <p>Additionally, we place a strong emphasis on risk mitigation, safeguarding our operations, manpower, and assets through comprehensive insurance coverage. This proactive approach to risk management helps us maintain financial stability and continuity, while also ensuring the protection of our key resources.</p></div>`,
        image: allImages.finance,
        reverse: true
    }
];
const OtherServices: SubServices[] = [
    {
        id: 0,
        heading: "Oil & Gas",
        content: "<ul><li>PBL provides crane lifting equipment and transportation services for exploration and maintenance.</li><li><strong>Cranes for Rig Sites & Greenfield Plants:</strong> Lifting and installing heavy equipment, machinery, and infrastructure.</li><li><strong>Transportation of Pipes & Chemicals:</strong> Safe transport of pipes and hazardous chemicals using specialized trailers.</li><li><strong>Multiaxle Trailers:</strong> Moving oversized equipment and machinery during exploration and construction.</li><li><strong>Manlifts:</strong> Providing elevated work platforms for hard-to-reach areas like drilling rigs and production platforms.</li></ul>",
        image: allImages.oil,
        reverse: false
    },
    {
        id: 1,
        heading: "Energy(Solar and Windmill Projects)",
        content: "<ul><li>PBL provides crane hire and ODC transportation services for EPC companies in renewable energy projects.</li><li><strong>Handling Wind Turbine Components:</strong> Transporting oversized nacelles and turbine parts using specialized trailers.</li><li><strong>Solar Infrastructure:</strong> Crane services for installing large solar panel racks and supporting structures in solar farms.</li></ul>",
        image: allImages.energy,
        reverse: false
    },
    {
        id: 2,
        heading: "Transformers",
        content: "<ul><li>PBL specializes in the transportation and movement of transformers using specialized trailers and cranes.</li><li>Ensuring safe handling and installation at power plants, substations, and infrastructure sites.</li></ul>",
        image: allImages.projectcargo,
        reverse: false
    },
    {
        id: 3,
        heading: "Mining",
        content: "<ul><li>PBL facilitates the transport of heavy mining equipment like excavators and dumpers using cranes and trailers.</li><li>Relocating large machinery across challenging terrain to ensure smooth mining operations.</li></ul>",
        image: allImages.mining,
        reverse: false
    },
    {
        id: 4,
        heading: "Roads and Railways",
        content: "<ul><li><strong>Steel Material Transportation:</strong> Movement of steel materials for road construction projects.</li><li><strong>Precast Concrete (PSC) Girders:</strong> Transport and erection of precast prestressed concrete girders for railway and metro projects.</li><li><strong>Underpasses & Bridges:</strong> Coordination for construction projects requiring high precision crane deployment.</li></ul>",
        image: allImages.railway,
        reverse: false
    },
    {
        id: 5,
        heading: "PSUs, Plants, and Factories",
        content: "<ul><li>Annually transports lakhs of MT of steel rebars and plates for private and public steel plants.</li><li><strong>Oversized Equipment Transport:</strong> Use of heavy-duty trailers (multi-axle, lowboy, long bed) for reactors, pressure vessels, and large tanks.</li><li><strong>Collaboration with EPC Companies:</strong> Providing cranes and material handling equipment for large-scale factory construction, shutdowns, and expansions.</li></ul>",
        image: allImages.factory,
        reverse: false
    },
    {
        id: 6,
        heading: "International Presence Bhutan & Sri Lanka",
        content: "<ul><li><strong>Bhutan:</strong> Crane operations for BHEL Hydropower project and HIRA Power Ferroalloy Plants.</li><li><strong>Sri Lanka:</strong> Crane hire services for road and bridge construction projects, ensuring efficient lifting and placement of materials.</li></ul>",
        image: allImages.international,
        reverse: false
    }
]
const SocialMediaLinks = [
    {
        name: "Facebook",
        link: "https://www.facebook.com/profile.php?id=61551094424720",
        color: "#4267B2",
        icon: <LuFacebook />
    },
    {
        name: "X",
        link: "https://twitter.com/pbl_limited",
        color: "#333",
        icon: <BsTwitterX />
    },
    {
        name: "Youtube",
        link: "https://www.youtube.com/channel/UCyZLAYye0RqeGRv6lPa22Cw",
        color: "#ff0000",
        icon: <LuYoutube />
    },
    {
        name: "Instagram",
        link: "https://www.instagram.com/pbl_transport_corp_pvt_ltd/",
        color: "#E1306C",
        icon: <LuInstagram />
    },
    {
        name: "Linkedin",
        link: "https://www.linkedin.com/company/pbl-transport-corporation-private-limited/",
        color: "#4267B2",
        icon: <LuLinkedin />
    },
]






export { youtubevideos, strengths, GalleryList, leaders, SubServicesdata, testimonials, clients, blogs, OtherServices, services, SocialMediaLinks, branches };